export default __webpack_public_path__ + "static/media/image35.3bb51076.png";